import {parsePartialProps, parseProps, PropsParser} from "@webng/validations";

function parseMetaTags(prefix: string) {
  const metaTags = document.querySelectorAll(`meta[property^="${prefix}:"]`);
  const metaValues: Record<string, string> = {};

  metaTags.forEach(tag => {
    const property = tag.getAttribute('property');
    if (property) {
      const propertyName = property.substring(prefix.length + 1); // +1 for the colon
      const content = tag.getAttribute('content');
      if (content) {
        metaValues[propertyName] = content;
      }
    }
  });

  return (key: string | number | symbol) => metaValues[key as string] || null;
}

export function parseTagProps<T>(parser: PropsParser<T>, el: Element) {
  // Get the element tag name to use as the meta tag prefix
  const tagName = el.tagName.toLowerCase();
  const metaTagRetriever = parseMetaTags(tagName);

  // Create a retriever that first checks the element attribute, then falls back to meta tag
  const combinedRetriever = (key: string | number | symbol) => {
    const attrValue = el.getAttribute(key as string);
    return attrValue !== null ? attrValue : metaTagRetriever(key);
  };

  return parseProps(parser, combinedRetriever);
}

export function parsePartialTagProps<T>(parser: PropsParser<T>, el: Element) {
  // Get the element tag name to use as the meta tag prefix
  const tagName = el.tagName.toLowerCase();
  const metaTagRetriever = parseMetaTags(tagName);

  // Create a retriever that first checks the element attribute, then falls back to meta tag
  const combinedRetriever = (key: string | number | symbol) => {
    const attrValue = el.getAttribute(key as string);
    return attrValue !== null ? attrValue : metaTagRetriever(key);
  };

  return parsePartialProps(parser, combinedRetriever);
}

const domPrefix = "tik4"
export function dataAttributeName(name: string|number|symbol) {
  return `data-${domPrefix}-${String(name)}`
}

export function parseDataTagProps<T>(parser: PropsParser<T>, el: Element) {
  return parseProps(parser, k => el.getAttribute(dataAttributeName(k)))
}


function queryAttributeName(name: string) {
  const snakeCaseName = name.replace(/([A-Z])/g, '_$1').toLowerCase();
  return `tickaroo_${snakeCaseName}`
}

export function parseQueryProps<T>(parser: PropsParser<T>) {
  // const searchParams = window.location.search ? new URLSearchParams(window.location.search) : new URLSearchParams({})
  const hashParams = window.location.hash ? new URLSearchParams(window.location.hash.substr(1)) : new URLSearchParams({})

  return parseProps(parser, k => hashParams.get(queryAttributeName(k as string)))
}

export function parsePartialQueryProps<T>(parser: PropsParser<T>) {
  // const searchParams = window.location.search ? new URLSearchParams(window.location.search) : new URLSearchParams({})
  const hashParams = window.location.hash ? new URLSearchParams(window.location.hash.substr(1)) : new URLSearchParams({})

  return parsePartialProps(parser, k => hashParams.get(queryAttributeName(k as string)))
}

export function parseDefaultProps<T>(parser: PropsParser<T>) {
  return parseProps(parser, k => null)
}
